export default "__VITE_ASSET__81288bda__"